


import createUserFavBlogMutation from '@/apollo/mutations/user/createUserFavBlogMutation'
import deleteUserFavBlogMutation from '@/apollo/mutations/user/deleteUserFavBlogMutation'
import userFavBlogQuery from '@/apollo/queries/user/userFavBlogQueryWithLogin'
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

export default {
  name: 'ToggleFavouriteBlog',

  mixins: [eventTrackingMixins],

  props: {
    size: {
      type: String,
      default: 'small',
    },
    blogId: String,
    propFavBlogId: String,
  },

  data() {
    return {
      isFavourite: false,
      disableHover: false,
      favBlogId: this.propFavBlogId,
    };
  },

  apollo: {
    favBlog: {
      prefetch: true,
      fetchPolicy: 'no-cache',
      query: userFavBlogQuery,
      variables() {
        const returnObj = {};
        return returnObj;
      },
      context() {
        let contextObj = {};
        const authToken = localStorage.getItem('apollo_token')
        contextObj = {
          headers: {
            Authorization: `Bearer ${authToken}`,
          }
        }
        return contextObj;
      },
      update(data) {
        return this.$normalizeStrapi(data?.me?.FavBlogs?.data);
      },
      result({ data }) {
        // console.debug("FAV BLOG LIST");
        // console.debug(JSON.stringify(this.$normalizeStrapi(data?.userFavBlogs?.data)));
        // console.debug(this.blogId.toString());
        if (data?.me?.FavBlogs?.data) {
          const blogs = this.$normalizeStrapi(data?.me?.FavBlogs?.data);

          const matchedFavBlog = blogs.filter(item => {
            return item.Blog.id.toString() === this.blogId.toString();
          });

          if (matchedFavBlog.length > 0) {
            this.isFavourite = true;
            this.favBlogId = matchedFavBlog[0].id;
          }
        }
      },
      skip() {

        return this.propFavBlogId || !this.$store.state.auth.loggedIn;

      }
    }
  },

  mounted() {
    if (this.propFavBlogId) {
      this.favBlogId = this.propFavBlogId;
      this.isFavourite = true;
    }
    else
    {
      const pendingMyfavBlogs = this.$store.getters['myfav/myfavBlogs'];
      if(pendingMyfavBlogs.length > 0)
      {
        if (this.$store.state.auth.loggedIn) {
          if(pendingMyfavBlogs.indexOf(this.blogId)!== -1)
          {
            this.toggleFavouriteBlog();
            this.$store.commit('myfav/setMyfavBlogs', this.blogId);
          }
        }
        else
        {
          this.$store.commit('myfav/removeAllMyFavBlogs');
        }
      }
    }
  },

  updated() {
    if (this.propFavBlogId) {
      this.favBlogId = this.propFavBlogId;
      this.isFavourite = true;
    }
    else
    {
      const pendingMyfavBlogs = this.$store.getters['myfav/myfavBlogs'];
      if(pendingMyfavBlogs.length > 0)
      {
        if (this.$store.state.auth.loggedIn) {
          if(pendingMyfavBlogs.indexOf(this.blogId)!== -1)
          {
            this.toggleFavouriteBlog();
            this.$store.commit('myfav/setMyfavBlogs', this.blogId);
          }
        }
        else
        {
          this.$store.commit('myfav/removeAllMyFavBlogs');
        }
      }
    }
  },

  methods: {
    async toggleFavouriteBlog() {
      if (this.$store.state.auth.loggedIn) {
        this.isFavourite = !this.isFavourite;
        console.debug(this.isFavourite);
        if (this.isFavourite) {
          this.disableHover = true;

          const userId = this.$store.state.auth.user.id;

          const blogId = this.blogId;

          const vars = {
            "data": {
              "User": userId,
              "Blog": blogId
            }
          };

          console.debug(vars);

          const authToken = localStorage.getItem('apollo_token');
          // console.log(authToken);

          await this.$apollo.mutate({
            mutation: createUserFavBlogMutation,
            variables: vars,
            context: {
              headers: {
                Authorization: `Bearer ${authToken}`,
              }
            }
          }).then((apolloRes) => {
            const data = this.$normalizeStrapi(apolloRes.data.createUserFavBlog.data);
            this.favBlogId = data.id;
            // console.debug(JSON.stringify(data));
            
            this.handleEventTracking_saveBlog()
          });
        }
        else {
          console.debug("unfav: " + this.favBlogId);

          const authToken = localStorage.getItem('apollo_token');

          await this.$apollo.mutate({
            mutation: deleteUserFavBlogMutation,
            variables: {
              id: this.favBlogId
            },
            context: {
              headers: {
                Authorization: `Bearer ${authToken}`,
              }
            }
          }).then((apolloRes) => {
            this.$emit('unfavourite', this.favBlogId);
          });
        }
      }
      else {
        // this.$store.commit('modal/setShowLoginModal', true);
        this.$store.commit('myfav/setMyfavBlogs', this.blogId);
        this.$store.commit('modal/setLoginModalEntryPoint', 'my_save_page_popup');
        this.$auth.loginWith('tenlife');
      }
    },

    makeDisableHover() {
      this.disableHover = false;
    },
    
    handleEventTracking_saveBlog() {

      const eventTrackingParams = this.initEventTrackingParams()
      // #96 
      eventTrackingParams.a = 'save_blog'
      eventTrackingParams.l =  null
      eventTrackingParams.c = `blog_icon`
      eventTrackingParams.cd.insurer_name = null
      eventTrackingParams.cd.product_name = null
      eventTrackingParams.cd.product_category = null

      this.sendEventTracking(eventTrackingParams)
      }
  },
};
